<template name="filterpupils">
  <transition>
    <div
      class="
        flex
        md:flex-row
        flex-col
        items-start
        justify-start
        px-6
        py-0
        w-full
        z-50
        absolute
        -mt-3
        lg:ml-20
      "
    >
      <div
        id="popover"
        class="
          transition
          duration-150
          ease-in-out
          md:mt-0
          mt-0
          top-0
          left-0
          sm:ml-10
          md:ml-10
          w-11/12
          lg:w-6/12
          z-50
        "
      >
        <div class="w-full bg-white border rounded-lg shadow-2xl">
          <div class="relative bg-gray-200 rounded-t py-3 px-4">
            <div class="flex justify-between">
              <button
                class="
                  focus:underline focus:text-gray-600
                  hover:text-gray-600
                  focus:outline-none
                  text-gray-800
                  cursor-pointer
                  md:block
                "
                @click="$emit('close')"
              >
                <i class="fas fa-times close-icon text-lg" title="Close"></i>
              </button>

              <button
                class="
                  focus:text-gray-600
                  hover:text-gray-600
                  focus:outline-none
                  text-gray-800
                  cursor-pointer
                  md:block
                  pr-2
                  text-xs
                "
                @click="resetFilter()"
              >
                <i class="fas fa-redo pr-1 txt-xs" title="Clear"></i> Clear
                filter
              </button>
            </div>

            <i
              class="
                fas
                fa-caret-up
                hidden
                md:block
                absolute
                top-0
                -mt-6
                mr-48
                right-0
                bottom-0
                text-5xl text-gray-200
              "
            ></i>
          </div>
          <div class="w-full h-full pl-4 pr-3">
         

            <div class="grid grid-cols-2 gap-4">
              <div>

                <div class="form-box border-gray-50 border-opacity-25">
                  <div class="form-box-title">Class / Group</div>
                  <p class="">
                    <ClassDropdown :classSelected="filteredClass" @classValueChanged="classSelect"
                    v-bind:class="
                        filteredClass.id > 0
                          ? 'filter-item-button-on text-gray-900'
                          : 'filter-item-button-off'
                      "></ClassDropdown>
                    
                  </p>
                </div>

                <div class="form-box border-0">
                  <div class="form-box-title">Year Groups</div>

                  <ul class="mb-1 w-full">
                    <li
                      v-for="item in yearDropdown"
                      :key="item.key_value"
                      class="inline-block mr-2"
                    >
                      <button
                        type="button"
                        @click="filterYearValue(item.key_value)"
                        class="filter-item-button hover:bg-opacity-50 wide"
                        v-bind:class="
                          inYearFilter(item.key_value)
                            ? 'filter-item-button-on'
                            : 'filter-item-button-off'
                        "
                      >
                        <i
                          class="far pr-1"
                          v-bind:class="
                            inYearFilter(item.key_value)
                              ? 'fa-check-square'
                              : 'fa-square'
                          "
                        ></i>
                        Y{{ item.letter }}
                      </button>
                    </li>
                  </ul>
                </div>
      
              </div>

              <div class="border-l border-gray-50 pl-5">
                <div class="form-box border-gray-50 border-opacity-25">

           
                  <div class="form-box-title flex justify-between w-full">Search Tags
                    <div class="flex"> 
                      <div class="bg-blue-500 tag-example mr-2 w-10"
                      @click="addTags('sen')">#sen</div>

                      <div class="bg-orange-500 tag-example"
                      @click="addTags('ofsted')">#ofsted</div>
                    </div>
                    
                  </div>
                  <div class="relative">
                    <div
                      class="
                        flex
                        absolute
                        inset-y-0
                        left-0
                        items-center
                        pl-3
                        pointer-events-none
                      "
                    >
                      <svg
                        class="w-5 h-5 text-gray-500 dark:text-gray-400"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="2"
                          d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                        ></path>
                      </svg>
                    </div>
                    <input
                      type="search"
                      class="
                        h-full
                        text-gray-700
                        placeholder-gray-500
                        w-11/12
                        bg-gray-100
                        rounded
                        shadow-sm
                        p-2
                        pl-10
                        mr-3
                        mt-1
                      "
                      name="search"
                      v-model="tags"
                      placeholder="Enter tags to search..."
                    />
                  </div>
                </div>

                <div class="form-box no-border">
                  <div class="form-box-title">Criteria</div>

                  <ul class=" mb-1 w-full"  >

<li  v-for="item in typeDropdown" :key="item.value"  class="inline-block mr-2">
 <button type="button" @click="filterTypeValue(item.value)"
 class="filter-item-button hover:bg-opacity-50 wide"
 v-bind:class="
                          inTypeFilter(item.value)
                            ? 'filter-item-button-on'
                            : 'filter-item-button-off'
                        ">
   <i class="far pr-1" v-bind:class="inTypeFilter(item.value) ? 'fa-check-square': 'fa-square'" ></i> {{ item.name }}
   </button>

</li>      


</ul>

                  
                </div>
              </div>
            </div>
          </div>

          <div
            class="
              w-full
              text-center
              bg-gray-200
              pt-5
              rounded-br-lg rounded-bl-lg
            "
          >
            <button
              @click="filterButtonPressed()"
              class="
                mx-auto
                w-1/3
                mb-4
                focus:ring-2 focus:ring-offset-2
                rounded-md
                focus:ring-indigo-600
                transition
                duration-150
                ease-in-out
                hover:bg-indigo-600
                focus:outline-none
                bg-indigo-700
                rounded-r
                text-white
                px-3
                py-1
                text-sm
              "
            >
              Apply filter
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>

</template>

<script>

import { mapGetters } from "vuex";
import {
  filterTypeList,
} from "@/assets/js/utils";
import { yearGroupMixin} from "@/mixins/yearGroupMixin.js";
import { PupilFilter } from "@/services/pupil.service";

const ClassDropdown = () => import("@/components/pupil/ClassDropdown.vue");

export default {
  name: "filterpupils",
  mixins: [yearGroupMixin],
  props: {
    values: { type: Object, required: true },
  },
  computed: {
  ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess"
    }),

    yearDropdown() {
      var results = this.years
      return results;
    },
    typeDropdown() {
      let typeList = _.orderBy(this.types, ["id"]);
      return typeList;
    },
  },
  data() {
    return {
      types: filterTypeList(),
      filteredYears: [],
      filteredTypes: [],
      filteredClass: {},
      tags: "",
    }
  },
  created() {
  },
  mounted() {

    // set preset values if exist
    if (!!Object.keys(this.values).length) {
      if (this.values.years != undefined) {
        this.filteredYears = this.values.years;
      }

      if (this.values.group != undefined) {
        this.classSelect(this.values.group);
      }

      if (this.values.types != undefined) {
        this.filteredTypes = this.values.types;
      }

      if (this.values.tags !=undefined) {
        this.tags = this.values.tags
      }
     
    } 

   
  },
  watch: {

  },
  methods: {
    classSelect(value) {
      if (value != undefined) {
        this.filteredClass = value;
      } else {
        this.filteredClass = {}
      }
    },
    filterYearValue(value) {
       if (this.filteredYears.includes(value)) {
          this.filteredYears.splice(this.filteredYears.indexOf(value), 1);
      } else {
        this.filteredYears.push(value);
      }
    },
    inYearFilter(value) {
      return this.filteredYears.includes(value)
    },
    filterTypeValue(value) {
       if (this.filteredTypes.includes(value)) {
          this.filteredTypes.splice(this.filteredTypes.indexOf(value), 1);
      } else {
        this.filteredTypes.push(value);
      }
    },
    inTypeFilter(value) {
      return this.filteredTypes.includes(value)
    },
    resetFilter() {
      this.filteredYears = [];
      this.filteredCourse = {};
      this.selectedDate = {};
      this.filteredTypes = []
      this.tags = ""
      this.classSelect();
    },
    addTags(value) {
      let seperator = this.tags.length > 0 ? " #" : "#"
      this.tags = this.tags + seperator + value
    },
    filterButtonPressed() {

      let payloadYears =
        this.filteredYears.length > 0 ? this.filteredYears : undefined;
      let payloadClass =
        this.filteredClass.id > 0 ? this.filteredClass : undefined;
      let payloadTypes =
        this.filteredTypes.length > 0 ? this.filteredTypes : undefined;
      let searchPayload = this.tags != undefined ? this.tags : ""

      let payload = new PupilFilter(
        payloadYears,
        payloadClass,
        payloadTypes,
        "",
        searchPayload
      );
      this.$emit("apply-filter", payload);
    },
  },
  components: {
    ClassDropdown
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


</style>
